/**
 * @generated SignedSource<<92cd66ece11e208c4923002fc2022dd8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DebriefStatus = "DONE" | "FAILED" | "PENDING" | "RUNNING" | "%future added value";
export type ErrorKind = "DISCOURSE" | "GRAMMAR" | "LEXIS" | "PROSODY" | "%future added value";
export type Severity = "BLOCKING" | "MINOR" | "POLISH" | "%future added value";
export type DebriefViewStatusSubscription$variables = {
  sessionId: string;
};
export type DebriefViewStatusSubscription$data = {
  readonly debriefStatus: {
    readonly focusAreas: ReadonlyArray<{
      readonly kind: ErrorKind;
      readonly turns: ReadonlyArray<{
        readonly audioUrl: string | null | undefined;
        readonly errors: ReadonlyArray<{
          readonly explanation: string;
          readonly id: string;
          readonly learnerForm: string;
          readonly severity: Severity;
          readonly span: {
            readonly end: number;
            readonly start: number;
          } | null | undefined;
          readonly targetForm: string;
        }>;
        readonly id: string;
        readonly transcript: string;
      }>;
      readonly why: string;
    }>;
    readonly generatedAt: any | null | undefined;
    readonly goal: {
      readonly parts: ReadonlyArray<boolean>;
      readonly reached: boolean;
    } | null | undefined;
    readonly id: string;
    readonly language: string | null | undefined;
    readonly model: string;
    readonly status: DebriefStatus;
    readonly strengths: ReadonlyArray<string>;
    readonly summary: string;
  };
};
export type DebriefViewStatusSubscription = {
  response: DebriefViewStatusSubscription$data;
  variables: DebriefViewStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      }
    ],
    "concreteType": "Debrief",
    "kind": "LinkedField",
    "name": "debriefStatus",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "strengths",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "generatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DebriefGoal",
        "kind": "LinkedField",
        "name": "goal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reached",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parts",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FocusArea",
        "kind": "LinkedField",
        "name": "focusAreas",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "why",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Turn",
            "kind": "LinkedField",
            "name": "turns",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcript",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ErrorRecord",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "learnerForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "targetForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "explanation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ErrorSpan",
                    "kind": "LinkedField",
                    "name": "span",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "start",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "end",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DebriefViewStatusSubscription",
    "selections": (v2/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DebriefViewStatusSubscription",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "c3b5a661ddc4a43f9bd0e5d12dc5a0b8",
    "id": null,
    "metadata": {},
    "name": "DebriefViewStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription DebriefViewStatusSubscription(\n  $sessionId: ID!\n) {\n  debriefStatus(sessionId: $sessionId) {\n    id\n    status\n    summary\n    strengths\n    model\n    generatedAt\n    language\n    goal {\n      reached\n      parts\n    }\n    focusAreas {\n      kind\n      why\n      turns {\n        id\n        transcript\n        audioUrl\n        errors {\n          id\n          severity\n          learnerForm\n          targetForm\n          explanation\n          span {\n            start\n            end\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51afa81acd7b3f113b73c5ed0bbf1502";

export default node;
